<template>
	<h4 v-html="content"></h4>
</template>

<script>
export default {
  name: 'heading',
  props: ['content']
}
</script>